<button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail no-focus" (click)="editAlert()">
    <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
</button>
